import { useCallback } from "react";
import { useLocalStorage } from "../../lib/localStorage";

export function useStoredSidebarCollapsed(): [
  boolean,
  (collapsed: boolean) => void,
] {
  const [value, setValue] = useLocalStorage("sidebarCollapsed");

  const collapsed = value === "true";
  const setCollapsed = useCallback(
    (collapsed: boolean) => {
      setValue(collapsed ? "true" : undefined);
    },
    [setValue],
  );

  return [collapsed, setCollapsed];
}
